import { render, staticRenderFns } from "./VerificationFormGeoRisk.vue?vue&type=template&id=6d0df6b6&"
import script from "./VerificationFormGeoRisk.vue?vue&type=script&lang=js&"
export * from "./VerificationFormGeoRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports